import { render, staticRenderFns } from "./AddWhatsapp.vue?vue&type=template&id=6361340d&"
import script from "./AddWhatsapp.vue?vue&type=script&lang=js&"
export * from "./AddWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports